import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Draft = forwardRef<SVGSVGElement | null, IconFilledProps>(function Draft({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M7.75 6.5C7.75 6.08579 8.08579 5.75 8.5 5.75H14C14.4142 5.75 14.75 6.08579 14.75 6.5C14.75 6.91421 14.4142 7.25 14 7.25H8.5C8.08579 7.25 7.75 6.91421 7.75 6.5Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M8.5 9.25C8.08579 9.25 7.75 9.58579 7.75 10C7.75 10.4142 8.08579 10.75 8.5 10.75H10.5C10.9142 10.75 11.25 10.4142 11.25 10C11.25 9.58579 10.9142 9.25 10.5 9.25H8.5Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.75 4.5C4.75 3.25736 5.75736 2.25 7 2.25H13.5C16.6756 2.25 19.25 4.82436 19.25 8V19.5C19.25 20.7426 18.2426 21.75 17 21.75H7C5.75736 21.75 4.75 20.7426 4.75 19.5V4.5ZM7 3.75C6.58579 3.75 6.25 4.08579 6.25 4.5V19.5C6.25 19.9142 6.58579 20.25 7 20.25H17C17.4142 20.25 17.75 19.9142 17.75 19.5V8C17.75 5.65279 15.8472 3.75 13.5 3.75H7Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7 2.25C5.75736 2.25 4.75 3.25736 4.75 4.5V19.5C4.75 20.7426 5.75736 21.75 7 21.75H17C18.2426 21.75 19.25 20.7426 19.25 19.5V8C19.25 4.82436 16.6756 2.25 13.5 2.25H7ZM7.75 6.5C7.75 6.08579 8.08579 5.75 8.5 5.75H14C14.4142 5.75 14.75 6.08579 14.75 6.5C14.75 6.91421 14.4142 7.25 14 7.25H8.5C8.08579 7.25 7.75 6.91421 7.75 6.5ZM7.75 10C7.75 9.58579 8.08579 9.25 8.5 9.25H10.5C10.9142 9.25 11.25 9.58579 11.25 10C11.25 10.4142 10.9142 10.75 10.5 10.75H8.5C8.08579 10.75 7.75 10.4142 7.75 10Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'draft-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Draft;
